/* REACT */
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

/* 3RD PARTIES */
import axios from 'axios'
import get from 'lodash.get'

/* COMPONENTS */
import ShowIntentComponent from './ShowIntentComponent'
import { Spinner } from '../../../../components/ui'

/* STORE */
import { getGrids } from '../../../../store/maya/selectors'

/* STYLES */
import { IntentWrapper, IntentBackgroundImg } from './style'

/* UTILS/CONSTANTS */
import {
  MAYA_INTENTS,
  CLOUDFRONT_BASE_URL,
  CLIENT_STYLINGS,
} from '../../../../utils/constants'
import { getTranslations } from '../../../../utils'

/* ASSETS */

const MayaIntentComponent = ({
  router,
  isLessThanLaptop,
  intent,
  language,
  grids,
  organizationSlug,
  isFetchingIntent,
}) => {
  const ChatBgImage = get(
    CLIENT_STYLINGS,
    `${organizationSlug}.CHAT_BG_IMAGE`,
    ''
  )

  const scrollToTop = () => {
    if (
      document.querySelector('#intent-recommendation-wrapper')?.scrollTop !== 0
    ) {
      // ON NEW DATA FETCH GO TO TOP OF PAGE
      let section = document.querySelector('#intent-recommendation-wrapper')
      if (section) {
        section.scrollTo({
          top: 0,
          block: 'start',
          behavior: 'smooth',
        })
      }
    }
  }

  useEffect(() => {
    scrollToTop()
  }, [isFetchingIntent])

  return (
    <IntentWrapper>
      {intent &&
      (intent?.type === MAYA_INTENTS.recommend_destination.KEY ||
        intent?.type === MAYA_INTENTS.recommend_accomodation.KEY ||
        intent?.type === MAYA_INTENTS.recommend_trip.KEY ||
        intent?.type === MAYA_INTENTS.qa.KEY ||
        intent?.type === MAYA_INTENTS.llt_qa.KEY ||
        intent?.type === MAYA_INTENTS.event.KEY ||
        intent?.type === MAYA_INTENTS.business.KEY ||
        intent?.type === MAYA_INTENTS.trending.KEY ||
        intent?.type === MAYA_INTENTS.entity_specific_qa.KEY) ? (
        <ShowIntentComponent
          router={router}
          isLessThanLaptop={isLessThanLaptop}
          grids={grids}
          language={language}
          intent={intent}
          organizationSlug={organizationSlug}
          
        />
      ) : (
        <>
          {isFetchingIntent ? (
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundColor:
                  CLIENT_STYLINGS[organizationSlug].COLOR.BACKGROUND,
                opacity: '0.8',
                zIndex: '100',
                position: 'absolute',
              }}
            >
              {' '}
              <Spinner
                isBasic={false}
                interval={10000}
                messages={getTranslations(
                  intent
                    ? `updating_recommendations_${intent?.type}`
                    : `updating_recommendations_qa`
                )}
              />
            </div>
          ) : null}
          {ChatBgImage ? (
            <IntentBackgroundImg
              src={ChatBgImage}
              alt='chat-background'
              fill={true}
            />
          ) : null}
        </>
      )}
    </IntentWrapper>
  )
}

const mapStateToProps = state => {
  return {
    user: state?.auth?.user,
    intent: state?.maya?.intent,
    grids: getGrids(state),
    organizationSlug: state?.general?.organizationSlug,
    isFetchingIntent: state?.maya?.isFetchingIntent,
  }
}

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MayaIntentComponent)
